module.exports = __webpack_public_path__ + "img/image-hero-3-mobile.63cd3600.png";